module.exports = __webpack_public_path__ + "static/media/HighScoreGirl.d1e7b08a.svg";